import React from 'react';
export function PriceTag() {
  return <div className="mt-3" data-id="element-145">
      <div className="flex items-center justify-center gap-3" data-id="element-146">
        <span className="text-cream/40 line-through text-sm md:text-base font-semibold" data-id="element-147">
          $19.99
        </span>
        <span className="text-[#4ADE80] font-extrabold text-2xl md:text-3xl tracking-tight" data-id="element-148">
          $6.39
        </span>
        <span className="bg-[#4ADE80]/15 text-[#4ADE80] text-[10px] md:text-xs font-extrabold px-2.5 py-1 rounded-full border border-[#4ADE80]/30 uppercase tracking-wider" data-id="element-149">
          68% Off
        </span>
      </div>
      <p className="text-cream/35 text-[9px] md:text-[11px] font-light tracking-wide text-center mt-1.5" data-id="element-150">
        Immediate access · One‑time secure payment
      </p>
    </div>;
}